import React from 'react';
import ClassAssembly  from 'views/ClassAssembly8C2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;